import React from "react";

const ParentPeopleLevelPointer = ({positionPercent}) => {

  const size = 12;
  const xPosition = `calc(${positionPercent}% - ${size/2}px)`; // minus the half the width of the pointer triangle

  const x = '10%'
  return <div className="_pointer" style={{height: size, width: size, left: xPosition, display: 'block'}}>
    <svg
      width={`${size}`}
      height={`${size}`}
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M 15,0 L 30,30 L 0,30 Z" fill="black" />
    </svg>
  </div>;
};

export default ParentPeopleLevelPointer;
